import HTTP from '../common/http-common';

const END_POINT = '/company/position';

const listPosition = () => HTTP.get(END_POINT, { cache: false });

const insertPosition = (data) => HTTP.post(END_POINT, {
    positionCode: data.positionCode,
    positionName: data.positionName,
    positionGroup: data.positionGroup
});

const deletePosition = (code) => HTTP.delete(END_POINT + "/" + code);

export {
    listPosition,
    insertPosition,
    deletePosition
}